<div class="container-fluid">
    <div class="row">
        <div class="col-xl-12 col-md-6 p-0 m-0">
            <p class="mb-0 text-center">Copyright 2023 © <a href="https://www.bee-seller.com/"
                    target="_blank">Bee-Seller</a>
                {{'Footer' | translate}}</p>
        </div>
    </div>
</div>